import { render, staticRenderFns } from "./BaseSnake.vue?vue&type=template&id=8901ad86&scoped=true"
import script from "./BaseSnake.vue?vue&type=script&lang=js"
export * from "./BaseSnake.vue?vue&type=script&lang=js"
import style0 from "./BaseSnake.vue?vue&type=style&index=0&id=8901ad86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8901ad86",
  null
  
)

export default component.exports